// extracted by mini-css-extract-plugin
export default {"items":"Devices_items__zZbb5","message":"Devices_message__gThfg"};